// extracted by mini-css-extract-plugin
export default {"floatingText":"MaCrkh"};